// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8230) return "static/chunks/8230-ea6c4ad3b893fabd.js";
	if (chunkId === 3992) return "static/chunks/3992-eb4f19b43317fe4e.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8523 ? "8aa22271" : chunkId) + "." + {"2609":"6726074568d4bd1a","4753":"6b723bc33e1ebc79","5949":"008bcd1d709e39c9","8523":"73dcf5d38d9f665e"}[chunkId] + ".js";
};